import Vue from 'vue'
import Vuex from 'vuex'
import auth from '@/store/auth'
import branches from '@/store/branches'
import allUsers from '@/store/all-users'
import courses from '@/store/courses'
import categories from '@/store/categories'
import stage from '@/store/stage'
import storage from '@/store/storage'
import notifications from '@/store/notifications'
import search from '@/store/search'
import right from '@/store/right'
import groups from '@/store/groups'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    branches,
    allUsers,
    courses,
    categories,
    stage,
    storage,
    notifications,
    search,
    right,
    groups,
  },
  actions: {},
  state: {}
})
